var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyNetworkInactiveNavbar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1731_4917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 8.16667C5.83301 9.40434 6.32467 10.5913 7.19984 11.4665C8.07501 12.3417 9.262 12.8333 10.4997 12.8333C11.7374 12.8333 12.9243 12.3417 13.7995 11.4665C14.6747 10.5913 15.1663 9.40434 15.1663 8.16667C15.1663 6.92899 14.6747 5.742 13.7995 4.86683C12.9243 3.99167 11.7374 3.5 10.4997 3.5C9.262 3.5 8.07501 3.99167 7.19984 4.86683C6.32467 5.742 5.83301 6.92899 5.83301 8.16667Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 24.5V22.1667C3.5 20.929 3.99167 19.742 4.86683 18.8668C5.742 17.9917 6.92899 17.5 8.16667 17.5H12.8333C14.071 17.5 15.258 17.9917 16.1332 18.8668C17.0083 19.742 17.5 20.929 17.5 22.1667V24.5",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.667 3.65234C19.6708 3.90936 20.5605 4.49316 21.1959 5.31171C21.8313 6.13025 22.1761 7.13698 22.1761 8.17318C22.1761 9.20938 21.8313 10.2161 21.1959 11.0346C20.5605 11.8532 19.6708 12.437 18.667 12.694",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 24.5008V22.1674C24.4941 21.1375 24.1476 20.1384 23.5145 19.3259C22.8814 18.5135 21.9973 17.9333 21 17.6758",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1731_4917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyNetworkInactiveNavbar);
export default __webpack_public_path__ + "static/media/my-network-inactive-navbar.9b36ec23bfbaa0753e5be35e4f7d7ca0.svg";
export { ForwardRef as ReactComponent };